import React, { useMemo, useState } from "react";
import { Card, OptionList, Popover, RadioButton, Stack, TextField } from "@shopify/polaris";
import { renderDestination } from "app/shipping/modules/provider/features/subFeatures/advance/offers/propsType";

const RenderOfferDestination = (props) => {
  const {
    checkedDestination,
    renderRegion,
    handleDestination,
    popoverActive,
    activator,
    handleShippingDestination,
    destinationData,
    destinationCodes,
    togglePopoverActive,
    cms,
  } = props;

  const [regionSearch, setRegionSearch] = useState("");

  const filteredDestinations = useMemo(() => {
    if (!destinationData || !Array.isArray(destinationData) || !regionSearch) return destinationData;
    const search = regionSearch.toLowerCase().trim();
    return destinationData
      .map((section) => {
        const options =
          (section.options || []).filter((opt) => {
            return (
              (opt.label && opt.label.toLowerCase().includes(search)) ||
              (opt.value && String(opt.value).toLowerCase().includes(search)) ||
              (section.title && section.title.toLowerCase().includes(search))
            );
          }) || [];
        return { ...section, options };
      })
      .filter((section) => section.options && section.options.length);
  }, [destinationData, regionSearch]);

  return (
    <Card title={cms("label.destination")} sectioned>
      <Stack.Item>
        <RadioButton
          label={cms("modal.offer.add.section.destination.label.allDestination")}
          helpText={cms("modal.offer.add.section.destination.caption.allDestination")}
          checked={checkedDestination}
          id="all-destinations"
          name="all-destinations"
          onChange={handleDestination}
        />
      </Stack.Item>
      <Stack.Item>
        <RadioButton
          label={cms("modal.offer.add.section.destination.label.selectedDestinations")}
          helpText={cms("modal.offer.add.section.destination.caption.selectedDestination")}
          id="selected-destinations"
          name="selected-destinations"
          checked={!checkedDestination}
          onChange={handleDestination}
        />
      </Stack.Item>

      {!checkedDestination && [
        <Stack.Item>
          <Stack.Item>
            <Popover active={popoverActive} activator={activator} onClose={togglePopoverActive}>
              <div style={{ padding: "12px", minWidth: "320px", maxHeight: "400px", overflowY: "auto" }}>
                <Stack vertical spacing="tight">
                  <Stack.Item>
                    <TextField
                      value={regionSearch}
                      onChange={setRegionSearch}
                      placeholder={cms("modal.rule.add.placeholder.searchRegion") || "Search region or country"}
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <OptionList
                      onChange={(value) => {
                        handleShippingDestination(value);
                      }}
                      sections={filteredDestinations}
                      selected={destinationCodes}
                      allowMultiple
                    />
                  </Stack.Item>
                </Stack>
              </div>
            </Popover>
          </Stack.Item>
          <Stack.Item>{renderRegion()}</Stack.Item>
        </Stack.Item>,
      ]}
    </Card>
  );
};

RenderOfferDestination.propTypes = renderDestination.type;

export default RenderOfferDestination;
